<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.kapatma_talepleri"  url="CreateProject" :show_button="false" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader>

<div class="content_card_content">




<DataTable 
:value="items"  
:lazy="true" 
:paginator="true" 
class="p-datatable-suppliers" 
:rows="limit"
dataKey="id" 
:page="page+1"
:first="first"
:rowHover="true"  
v-model:filters="filters" 
:reorderableColumns="true"
:totalRecords="totalRecords"
filterDisplay="menu" 
:loading="loading"
@page="onPage($event)" 
@filter="onFilter($event)"
@sort="onSort($event)" 
paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
:rowsPerPageOptions="[5,10,25,50,100]"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
:globalFilterFields="globalFilterFields" 
responsiveLayout="scroll"
>

<template #empty>
No item found.
</template>
<template #loading>
<div class="loading_overlay">
<ProgressSpinner style="width:50px;height:50px" strokeWidth="4" color="deneme" />
Loading data. Please wait.
</div>
</template>
    <Column  :header="$store.state.languages.lang_phrases.isim" sortable field="name">
      <template #body="{data}">
        <router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'Supplier' , params: {id:data.supplier_id}}"><p>{{data.name}}</p></router-link>
    </template>
    </Column>
    <Column  :header="$store.state.languages.lang_phrases.tedarikci_kodu" sortable field="suppliercode">
      <template #body="{data}">
        <p>{{data.suppliercode}}</p>
    </template>
    </Column>
    <Column sortable field="brand_name" :header="$store.state.languages.lang_phrases.marka" ></Column>
    <Column sortable field="flow_name" :header="$store.state.languages.lang_phrases.akis" ></Column>
    <Column sortable field="nonconformity_type_name" :header="$store.state.languages.lang_phrases.uygunsuzluk_tipi" ></Column>


    <Column sortable field="nonconformityclosure_status"  :header="$store.state.languages.lang_phrases.durum" :filterMenuStyle="{'width':'14rem'}" style="min-width:12rem">
<template #body="{data}">

<Tag 
class="mr-2 mt-1 custom-chip" 
v-for=" element in statuses"  
v-show="element.name==data.nonconformityclosure_status"
:value="$store.state.languages.lang_phrases[element.text]" 
:style="'background-color:'+element.color"
/>

</template>

</Column>

 <Column field="updated_at" :header="$store.state.languages.lang_phrases.guncelleme_tarihi" sortable dataType="date" style="min-width: 8rem">
      <template #body="{data}">
          {{ $filters.momentFormat( data.updated_at," Do MM YYYY hh:mm")}}
      </template>
  </Column>


    <Column>
      <template #body="{data}">
        <router-link :to="{ name: 'SupplierFlowNonconformity' , params:{id:data.supplier_id,nonconformity_id:data.nonconformity_id}}" target="_blank" >
          <Button label="Görüntüle"  class="p-button-white  p-button-sm rightmargin"  />
      </router-link>
        
      </template>

    </Column>
</DataTable>













</div>





</div>







</div>
</template>

<script>
  import {FilterMatchMode,FilterOperator} from 'primevue/api';
import TableTag from "../../components/pagecomponents/TableTag"
export default {

  name: 'NonconformityClosureRequests',
  components:{TableTag},
  data () {
    return {
      loading: false,  
      items:[],
      list_route:"latest_nonconformities",
      page:0,
      limit:10,   
      first:0, 
      totalRecords:0, 
      sort_column:"updated_at",
      sort_order:"desc",
      filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'name': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
        'date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]},
        'status': {value: null, matchMode: FilterMatchMode.EQUALS},
        'nonconformityclosure_status': {value: null, matchMode: FilterMatchMode.EQUALS},
      },
      statuses:[
        {
          name:"pending",
          color:"#a855f7",
          text:"degerlendirmede",
        },
        {
          name:"rejected",
          color:"#dd4b39",
          text:"reddedildi",
        },
        {
          name:"approved",
          color:"#4dc247",
          text:"tamamlandi",
        },
        {
          name:"open",
          color:"#ff6600",
          text:"beklemede",
        },
      ],
      columns:[
      {
        type:"text",
        field:"name",
        header:"isim",
        hide_on_mobile:false,
      },      
      {
        type:"text",
        field:"suppliercode",
        header:"tedarikci_kodu",
        hide_on_mobile:true,
      },
      {
        type:"text",
        field:"brand_name",
        header:"marka",
        hide_on_mobile:true,
      },
      {
        type:"text",
        field:"flow_name",
        header:"akis",
        hide_on_mobile:true,
      }, 
      {
        type:"text",
        field:"nonconformity_type_name",
        header:"uygunsuzluk_tipi",
        hide_on_mobile:true,
      }, 
      {
        type:"pill",
        field:"nonconformityclosure_status",
        header:"durum",
        options:[
          {
            name:"pending",
            color:"#a855f7",
            text:"degerlendirmede",
          },
          {
            name:"rejected",
            color:"#dd4b39",
            text:"reddedildi",
          },
          {
            name:"approved",
            color:"#4dc247",
            text:"tamamlandi",
          },
          {
            name:"open",
            color:"#ff6600",
            text:"beklemede",
          },
        ],
      },     
      {
        type:"date",
        field:"created_at",
        header:"eklenme_tarihi",
        hide_on_mobile:false,
      },

      ]
    }
  },
  computed:{
    globalFilterFields()
    {
        let items = this.columns.map((item)=>{return item.field})
        return items

    },
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {      

      //let data = await this.generalApiGet("latest_nonconformities") 

      this.loading = true
      let data = await this.generalApiGetWithoutLoader("latest_nonconformities/"+this.page+"/"+this.limit+"?sort_column="+this.sort_column+"&sort_order="+this.sort_order)
        
      this.items = await data.data
      this.totalRecords = await data.meta.total       
      
      this.loading = false
      console.log(data);
      //await this.$store.dispatch('flows/setFlows',this.data)
    },
    onPage(event)
    {
        this.page = event.page
        this.getData()
        console.log(event)        
    },

    onFilter(event)
    {
        console.log("filter")
        console.log(event)
        //this.$emit("filter",event)
    },
    onSort(event)
    {
        console.log(this.globalFilterFields)
        this.sort_column = event.sortField
        if(event.sortOrder===1)
        {
            this.sort_order = "asc"
        }
        else
        {
            this.sort_order = "desc"
        }
        this.getData()

    },
    async goToProjectSummaryPage(data)
    {
      //let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+uuid)
      console.log(data)
      //return false
      await this.$router.push({ name: 'SupplierFlowNonconformity',params:{id:data.supplier_id,nonconformity_id:data.nonconformity_id} })
    },
    
  }
};
</script>

<style lang="css" scoped>
  .loading_overlay
{
    background-color:rgba(53, 47, 141, 0.5);
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    color:#fff;
    flex-direction:column;

}
</style>